const binded: any = {};

export const Bind = (key: string, object: any) => {
  binded[key] = object;
};

export const ResolveInjection = <T>(key: string) => binded[key] as T;
